import { useEffect, useState } from "react";

import { DataTable, PageHeader } from "@/components/admin-ui";
import { adminOpsClient } from "@/lib/api-clients";

export function PromotionsPage() {
  const [rows, setRows] = useState<Array<[string, string, string, string]>>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    void adminOpsClient
      .listPromotionServices()
      .then((services) => {
        setRows(
          services.map((service) => [
            service.code,
            service.name,
            String(service.creditCost),
            service.targetType,
          ]),
        );
      })
      .catch((err) => setError(err instanceof Error ? err.message : "โหลดไม่สำเร็จ"));
  }, []);

  return (
    <div className="space-y-6">
      <PageHeader title="Boost และโปรโมชัน" />
      {error ? <p className="text-sm text-error-text">{error}</p> : null}
      <DataTable headers={["Code", "Name", "Credit cost", "Target"]} rows={rows} />
    </div>
  );
}
